import script from "./accaCalendar.vue?vue&type=script&setup=true&lang=ts"
export * from "./accaCalendar.vue?vue&type=script&setup=true&lang=ts"

import "./accaCalendar.vue?vue&type=style&index=0&id=03ce592a&lang=css"

const __exports__ = script;

export default __exports__